module.exports = __webpack_public_path__ + "img/title.e97cd3ca.png";